import { ActionPromptType } from "./action-prompt-type";

export const getAddPairForActionPrompts = (type: ActionPromptType): ActionPromptType[] => {
    switch (type) {
        case ActionPromptType.JOIN_DRAW_FIRST_TIME:
            return [ActionPromptType.DRAWS_ADD];
        case ActionPromptType.CREATE_BUSINESS_FIRST_TIME:
            return [ActionPromptType.OFFICE_ADD, ActionPromptType.BUSINESS_ADD];
        case ActionPromptType.CONVERT_ENERGY_FIRST_TIME:
            return [ActionPromptType.OFFICE_ADD, ActionPromptType.WORK_ADD];
        case ActionPromptType.UPGRADE_WORK_FIRST_TIME:
            return [ActionPromptType.OFFICE_ADD, ActionPromptType.WORK_ADD, ActionPromptType.UPGRADE_WORK_ADD];
        case ActionPromptType.PASS_QUIZ_FIRST_TIME:
            return [ActionPromptType.TASKS_ADD];
        case ActionPromptType.COMPLETE_SUBSCRIPTION_TASK_FIRST_TIME:
            return [ActionPromptType.TASKS_ADD, ActionPromptType.SUBSCRIPTION_ADD];
        case ActionPromptType.UPGRADE_BUSINESS_FIRST_TIME:
            return [ActionPromptType.OFFICE_ADD, ActionPromptType.BUSINESS_ADD];
        case ActionPromptType.PLACE_ICON_ON_DESKTOP_FIRST_TIME:
            return [ActionPromptType.TASKS_ADD, ActionPromptType.PLACE_ICON_ADD];
        case ActionPromptType.AVAILABLE_SUBSCRIPTION_CHANNELS:
            return [ActionPromptType.TASKS_ADD, ActionPromptType.SUBSCRIPTION_ADD];
        default:
            return [ActionPromptType.NONE];
    }
};
